import { CARGO_TYPES, TRIP_TYPE, VEHICLE_TYPES } from "../constants/trip"

const VALID_VEHICLE_IDS = Object.values(VEHICLE_TYPES)
const VALID_CARGO_TYPES = Object.values(CARGO_TYPES)
const VALID_TRIP_TYPES = Object.values(TRIP_TYPE)

export const extractTripDataFromMessage = (content) => {
   const jsonMatch = content.match(/```json\s*([\s\S]*?)```/)
   if (!jsonMatch) return null

   try {
      const parsed = JSON.parse(jsonMatch[1])
      if (!parsed?.ready || !parsed?.trip_data) return null
      return parsed.trip_data
   } catch {
      return null
   }
}

export const validateTripData = (tripData) => {
   const errors = []

   if (!tripData.cargo_type || !VALID_CARGO_TYPES.includes(tripData.cargo_type)) {
      errors.push("Invalid cargo type")
   }

   if (tripData.cargo_type === CARGO_TYPES.CONTAINER) {
      if (!tripData.trip_category || !VALID_TRIP_TYPES.includes(tripData.trip_category)) {
         errors.push("Invalid trip category")
      }
   }

   if (tripData.item_size && !VALID_VEHICLE_IDS.includes(tripData.item_size)) {
      errors.push("Invalid vehicle type")
   }

   if (!tripData.start_address) {
      errors.push("Pickup address is required")
   }

   if (!tripData.end_address) {
      errors.push("Destination address is required")
   }

   return { valid: errors.length === 0, errors }
}

export const getVehicleLabel = (vehicleId) => {
   const entry = Object.entries(VEHICLE_TYPES).find(([, id]) => id === vehicleId)
   return entry ? entry[0] : "Unknown"
}

export const mapToFormData = (tripData) => {
   const formData = {
      cargo_type: tripData.cargo_type || CARGO_TYPES.CONTAINER,
      trip_category:
         tripData.cargo_type === CARGO_TYPES.LOOSE_GOODS
            ? TRIP_TYPE.LOCATION_LOCATION
            : tripData.trip_category || TRIP_TYPE.TERMINAL_LOCATION,
      item_size: tripData.item_size || "",
      offloading_duration: tripData.offloading_duration ? String(tripData.offloading_duration) : "",
      is_container_owner: tripData.cargo_type === CARGO_TYPES.LOOSE_GOODS ? true : !!tripData.is_container_owner,
      is_live_tracking_enabled: true,
      acceptBid: false,
      bid_price: "",
   }

   if (tripData.tonnage) {
      formData.tonnage = tripData.tonnage
   }
   if (tripData.container_number) {
      formData.container_number = tripData.container_number
   }
   if (tripData.cargo_category) {
      formData.cargo_category = tripData.cargo_category
   }
   if (tripData.cargo_description) {
      formData.cargo_description = tripData.cargo_description
   }
   if (tripData.cargo_value) {
      formData.cargo_value = tripData.cargo_value
   }
   if (tripData.customer_comment) {
      formData.customer_comment = tripData.customer_comment
   }

   return {
      data: formData,
      startAddress: tripData.start_address || "",
      endAddress: tripData.end_address || "",
      dropOffAddress: tripData.drop_off_address || "",
      startDate: tripData.start_time ? new Date(tripData.start_time) : "",
      tdoExpiryDate: tripData.tdo_expiry_date ? new Date(tripData.tdo_expiry_date) : new Date(),
   }
}
